'use client';

import { useEffect } from 'react';
import { usePathname, useRouter } from '@/i18n/routing';
import { useLicenseStatus } from '../hooks/use-license-status';

/**
 * Invisible app-wide guard. Redirects to /license-expired when the license
 * is expired — either reported by the public status endpoint (covers the
 * pre-auth login page) or signaled mid-session by the apiClient via the
 * `license-expired` window event (any API call returning LICENSE_EXPIRED).
 *
 * Deliberately does NOT log the user out: if the license is renewed, the
 * existing session resumes.
 */
export function LicenseGuard() {
  const router = useRouter();
  const pathname = usePathname();
  const { data } = useLicenseStatus();

  const expired = data?.expired === true;
  const onExpiredPage = pathname === '/license-expired';

  useEffect(() => {
    function handleLicenseExpired() {
      router.replace('/license-expired');
    }
    window.addEventListener('license-expired', handleLicenseExpired);
    return () =>
      window.removeEventListener('license-expired', handleLicenseExpired);
  }, [router]);

  useEffect(() => {
    if (expired && !onExpiredPage) {
      router.replace('/license-expired');
    }
  }, [expired, onExpiredPage, router]);

  return null;
}
